import { CountryISOCodes } from '../enums/phonevalidation-countries.constant';

export const countryCodes: Record<CountryISOCodes, string> = {
  [CountryISOCodes.KE]: '+254',
  [CountryISOCodes.UG]: '+256',
  [CountryISOCodes.AE]: '+971',
};
